import { render, staticRenderFns } from "./BqxsDetail.vue?vue&type=template&id=0d37ccbc&scoped=true&"
import script from "./BqxsDetail.vue?vue&type=script&lang=js&"
export * from "./BqxsDetail.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=0d37ccbc&prod&scoped=true&lang=css&"
import style1 from "../detail.css?vue&type=style&index=1&id=0d37ccbc&prod&scoped=true&lang=css&"
import style2 from "./BqxsDetail.vue?vue&type=style&index=2&id=0d37ccbc&prod&scoped=true&lang=css&"
import style3 from "./BqxsDetail.vue?vue&type=style&index=3&id=0d37ccbc&prod&scoped=true&lang=css&"
import style4 from "./BqxsDetail.vue?vue&type=style&index=4&id=0d37ccbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d37ccbc",
  null
  
)

export default component.exports